import { Link } from "react-router-dom";
import softwareImg from "../../../assets/Home-Page-Assets/software.png";
import metricsImg from "../../../assets/Home-Page-Assets/metrics.png";
import designImg from "../../../assets/Home-Page-Assets/design.png";
import codeImg from "../../../assets/Home-Page-Assets/code.png";
import qualityImg from "../../../assets/Home-Page-Assets/quality.png";
import projectImg from "../../../assets/Home-Page-Assets/metrics.png";
import Header from "../../../components/Headers/Header";
import arrow from "../../../assets/Home-Page-Assets/Arrow-3.png";
import { coreActivities } from "../../../data/coreActivities";

const iconMap = {
  software: softwareImg,
  metrics: metricsImg,
  design: designImg,
  code: codeImg,
  quality: qualityImg,
  project: projectImg,
};

const ActivitiesSection = () => {
  return (
    <div className="activities-block">
      <Header
        headerTitle="Our Activities"
        headerContent="We specialize in a diverse range of activities, including
                custom software development, system integration, and robust IT
                solutions to optimize business processes and enhance overall
                efficiency."
      />
      <div className="activities-body">
        <div className="container">
          <div className="icon-card-container">
            {coreActivities.map((card) => (
              <div key={card.id} className="icon-card">
                <div className="icon">
                  <img src={iconMap[card.iconKey]} alt="" aria-hidden="true" />
                </div>
                <div className="icon-text">
                  <h4>{card.title}</h4>
                  <p>{card.text}</p>
                </div>
              </div>
            ))}
            <Link to="/activities" className="word-button">
              <p>See more</p>
              <img src={arrow} alt="" aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivitiesSection;
